import Page from "../../components/Page";
import ComplianceReportSectionDetail from "../../components/Reports/complianceReport/ComplianceReportSectionDetail";

export const ComplianceReportDetailPage = () => {
    return (
      <Page>
        <ComplianceReportSectionDetail 
          isMobile={false}
        />
      </Page>
    );
  };
  
  export default ComplianceReportDetailPage;
  